import CrossSelling from './CrossSelling'

export default CrossSelling
